import { render, staticRenderFns } from "./mediabox.vue?vue&type=template&id=43315bac"
import script from "./mediabox.vue?vue&type=script&lang=js"
export * from "./mediabox.vue?vue&type=script&lang=js"
import style0 from "./mediabox.vue?vue&type=style&index=0&id=43315bac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports